import React from "react";


const HeroVenue = ({ heroAreaName, imageSrc }) => {
    console.log("Image source at smaller screens:", imageSrc);
    return (
        <section className="relative h-[700px] bg-cover bg-center"
            style={{
                backgroundImage: `url(${imageSrc})`
            }}
        >
            <div className="absolute inset-0 bg-black opacity-50"></div> {/* Dark overlay */}
            <div className="absolute inset-0 flex items-center justify-center text-center text-white">
                <div className="text-white">
                    <div className=" max-w-[800px] mt-[120px] w-full h-screen mx-auto text-center flex flex-col justify-center">
                        <h1 className="uppercase md:text-7xl text-4xl sm:text-5xl font-bold">{heroAreaName}</h1>
                    </div>

                </div>
            </div>
        </section>

    )
}

export default HeroVenue;

